<!-- Copyright (c) 2023 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div class="cargoType-main">
    <Menus :menu="menus" icon="https://dsmlib.logistics.systems/Icons/CargoType.png" @menuClicked="menuClicked" />
    <div class="right-container">
      <TableBox title="Cargo Type" :tableData="cargoTypeList" :selectedRow.sync="selectedCargoType" />
    </div>

    <PopupEntry
      v-if="popupEntryShow"
      :show.sync="popupEntryShow"
      :title="popupEntryTitle"
      :createdBy="createdBy"
      :disabledSave="popupEntryDisabledSave"
      :updatedBy="updatedBy"
      :viewMode="viewMode"
      :requiredError="entryError"
      :errorMessages="errorMessage"
      @requiredClicked="errorMessageClicked"
      :successMessages="successMessage"
      @save="saveCargoType"
    >
      <div class="CargoType-code">
        <Input
          validator="alphanumeric,5,uppercase"
          placeholder="Cargo Type Code (max. 5 characters)"
          :inputValue.sync="cargoType"
          :errorMessage.sync="cargoTypeCodeError"
          :isRequired="true"
          :isDisabled="viewMode || popupEntryTitle == 'Edit Cargo Type'"
          ref="cargoType"
        />
      </div>
      <div class="details">
        <Input
          :isDisabled="viewMode"
          placeholder="Description (max. 30 characters)"
          :inputValue.sync="description"
          :errorMessage.sync="cargoTypeDescriptionError"
          validator="text,30"
          ref="cargoTypeDescription"
        />
        <div class="additional-details">
          <Dropdown
            placeholder="Used in TMS?"
            :items="TMSList"
            :selectedObject.sync="selectedTMS"
            itemKey="label"
            :search.sync="selectedSearchTMS"
            :isDisabled="viewMode"
            :errorMessage.sync="TMSError"
            ref="cargoTypeTMS"
          />
          <Dropdown
            placeholder="Used in CON?"
            :items="CONList"
            :selectedObject.sync="selectedCON"
            itemKey="label"
            :search.sync="selectedSearchCON"
            :isDisabled="viewMode"
            :errorMessage.sync="CONError"
            ref="cargoTypeCON"
          />
          <Input
            placeholder="Demurrage Days (max. 255 days)"
            :inputValue.sync="DemurrageDays"
            :isDisabled="viewMode"
            :errorMessage.sync="DemurrageDaysError"
            validator="positiveInteger,3"
            ref="cargoTypeDemurrageDays"
          />
        </div>
      </div>
    </PopupEntry>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      //side menu list
      menus: [
        {
          title: 'New Cargo Type',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png',
          enabled: true,
          key: 'MnuNew',
          visible: true,
        },
        {
          title: 'Edit Cargo Type',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-edit-64%20(1).png',
          enabled: true,
          key: 'MnuEdit',
          visible: true,
        },
        {
          title: 'Delete Cargo Type',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png',
          enabled: true,
          key: 'MnuDelete',
          visible: false,
        },
        {
          title: 'View Cargo Type',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-view-64.png',
          enabled: true,
          key: 'MnuView',
          visible: true,
        },
      ],

      //table
      cargoTypeList: [],
      selectedCargoType: [],

      //popup entry
      popupEntryShow: false,
      popupEntryTitle: '',
      createdBy: '',
      updatedBy: '',
      viewMode: false,
      errorMessage: [],
      entryError: [],
      successMessage: [],
      selectedSearchTMS: '',
      selectedSearchCON: '',

      //fields
      cargoType: '',
      description: '',
      selectedTMS: null,
      DemurrageDays: '',
      selectedCON: null,
      saveAction: '',
      popupEntryDisabledSave: false,

      //error message
      cargoTypeCodeError: '',
      cargoTypeDescriptionError: '',
      DemurrageDaysError: '',
      TMSError: '',
      CONError: '',

      //TMS
      TMSList: [
        { '#': 1, label: 'No', TMSValue: '0' },
        { '#': 2, label: 'Yes', TMSValue: '1' },
      ],

      //CON
      CONList: [
        { '#': 1, label: 'No', CONValue: '0' },
        { '#': 2, label: 'Yes', CONValue: '1' },
      ],
    };
  },
  methods: {
    errorMessageClicked: function (item) {
      this.$nextTick(() => {
        this.$refs[item].setFocus();
      });
    },

    getCargoType: async function () {
      this.$fullscreenLoading('Getting Cargo Type');
      this.cargoTypeList = [];
      this.cargoTypeList = await this.$apiCallV2('/master/GetListMaster', { masterfile: 'CARGOTYPE_MASTER' });
      this.$fullscreenLoading();
    },

    saveCargoType: async function () {
      this.errorMessage = [];
      this.entryError = [];
      this.successMessage = [];
      const isValid = this.checkFields();
      if (isValid) {
        const dataToPost = {
          cargotypecode: this.cargoType,
          cargotypedescrpt: this.description,
          action: this.saveAction,
          tms: this.selectedTMS ? this.selectedTMS['TMSValue'] : '0',
          demurragedays: this.DemurrageDays.length ? this.DemurrageDays : 0,
          con: this.selectedCON ? this.selectedCON['CONValue'] : '0',
        };
        if (this.saveAction == 'E') {
          const change = await this.$showAlert(
            'warning',
            'Edit Cargo Type',
            `Are you sure you want to save the data that you had made changes to Cargo Type: "<b>${this.cargoType}</b>"`,
            [
              { text: 'Confirm', textColor: 'white', color: 'red' },
              { text: 'Cancel', textColor: 'black', color: 'lightgray' },
            ],
          );
          if (change == 'Cancel') {
            return;
          }
        }
        this.$fullscreenLoading('Saving Cargo Type');
        const postUpdate = await this.$apiCallV2('/CargoType/SaveCargoType', dataToPost);
        this.$fullscreenLoading();
        if (postUpdate[0].Results >= 1) {
          this.errorMessage.push('There was an error creating Cargo Type: ' + postUpdate[0].ErrMsg);
        } else {
          if (this.saveAction == 'N') {
            this.successMessage.push('Successfully created Cargo Type: ' + this.cargoType);
          }
          if (this.saveAction == 'E') {
            this.successMessage.push('Successfully edited Cargo Type: ' + this.cargoType);
          }
          this.viewMode = true;
          this.popupEntryTitle = 'View Cargo Type';
          this.popupEntryDisabledSave = true;
          this.getCargoType();
        }
      }
    },
    menuClicked: async function (e) {
      this.popupEntryDisabledSave = false;
      this.clearEntryMessages();
      switch (e['title']) {
        case 'New Cargo Type':
          this.clearCargoTypeDetails();
          this.popupEntryShow = true;
          this.popupEntryTitle = 'New Cargo Type';
          this.saveAction = 'N';
          this.selectedTMS = this.TMSList[0];
          this.selectedCON = this.CONList[0];
          this.DemurrageDays = '0';
          break;
        case 'Edit Cargo Type':
          if (this.selectedCargoType.length == 0) {
            this.$showAlert('error', 'No Cargo Type Selected', 'Please select a cargo type to edit');
          } else {
            this.popupEntryShow = true;
            this.popupEntryTitle = 'Edit Cargo Type';
            this.populateCargoTypeDetails();
            this.saveAction = 'E';
            await this.populateViewDetails(this.selectedCargoType[0]['Cargo Type']);
          }
          break;
        case 'View Cargo Type':
          if (this.selectedCargoType.length == 0) {
            this.$showAlert('error', 'No Cargo Type Selected', 'Please select a cargo type to view');
          } else {
            this.popupEntryShow = true;
            this.popupEntryTitle = 'View Cargo Type';
            this.populateCargoTypeDetails();
            this.viewMode = true;
            await this.populateViewDetails(this.selectedCargoType[0]['Cargo Type']);
          }
          break;
        case 'Delete Cargo Type':
          if (this.selectedCargoType.length == 0) {
            this.$showAlert('error', 'No Cargo Type Selected', 'Please select a cargo type to delete');
          } else {
            const deleting = await this.$showAlert(
              'warning',
              'Delete Cargo Type',
              `Are you sure you want to delete cargo type ${this.selectedCargoType[0]['Cargo Type']}? `,
              [
                { text: 'Delete', textColor: 'white', color: 'red' },
                { text: 'Cancel', textColor: 'black', color: 'lightgray' },
              ],
            );

            if (deleting == 'Delete') {
              const result = await this.$apiCallV2('/CargoType/SaveCargoType', {
                action: 'D',
                cargotypecode: this.selectedCargoType[0]['Cargo Type'],
              });
              if (result[0]['Results'] == 0) {
                // Deleted successful
                this.$showAlert(
                  'success',
                  'Cargo Type Deleted',
                  `Successfully deleted Cargo Type for ${this.selectedCargoType[0]['Cargo Type']}`,
                );
                this.$nextTick(async () => await this.getCargoType());
              } else {
                // Deleted error
                this.$showAlert(
                  'error',
                  'Cargo Type NOT Deleted',
                  `There was an error deleting Cargo Type for ${this.selectedCargoType[0]['Cargo Type']}`,
                );
              }
            }
          }
          break;
      }
    },
    populateCargoTypeDetails: function () {
      this.clearCargoTypeDetails();
      this.cargoType = this.selectedCargoType[0]['Cargo Type'];
      this.description = this.selectedCargoType[0]['Description'];
    },

    populateViewDetails: async function (record) {
      this.$fullscreenLoading('Getting Details');
      const details = (
        await this.$apiCallV2(`/Master/GetDetailsMaster`, { masterfile: 'CARGOTYPE', recordid: record })
      )['CargoType'];
      this.selectedTMS = details['TMS'] ? this.populateObject(this.TMSList, 'TMSValue', details['TMS']) : null;
      this.selectedCON = details['CON'] ? this.populateObject(this.CONList, 'CONValue', details['CON']) : null;
      this.DemurrageDays = details['DemurrageDays'];
      this.updatedBy = details['UserID'] + ' ' + details['DateUpdated'];
      this.createdBy = details['UserCreated'] + ' ' + details['TimeCreated'];
      this.$fullscreenLoading();
    },

    populateObject: function (data, key, compare) {
      //To populate object into dropdown or input query
      try {
        return data.find((d) => d[key].trim() == (compare ? compare.trim() : ''));
      } catch (error) {
        return null;
      }
    },

    clearCargoTypeDetails: function () {
      this.viewMode = false;
      this.cargoType = '';
      this.description = '';
      this.createdBy = '';
      this.updatedBy = '';
      this.saveAction = '';
      this.successMessage = [];
      this.errorMessage = [];
      this.selectedTMS = null;
      this.selectedCON = null;
      this.DemurrageDays = '';
      this.entryError = [];
    },

    checkFields: function () {
      this.clearEntryMessages();
      if (!this.cargoType) {
        this.cargoTypeCodeError = 'Cargo Type Code is required!';
        this.entryError.push({ key: 'cargoType', value: 'Cargo Type Code is required!' });
      }
      if (this.cargoType.length > 5) {
        this.cargoTypeCodeError = 'Cargo Type Code cannot be more than 5 characters!';
        this.entryError.push({ key: 'cargoType', value: 'Cargo Type Code cannot be more than 5 characters!' });
      }
      if (this.description.length > 30) {
        this.cargoTypeDescriptionError = 'Cargo Type Description cannot be more than 30 characters!';
        this.entryError.push({
          key: 'cargoTypeDescription',
          value: 'Cargo Type Description cannot be more than 30 characters!',
        });
      }
      if (!this.selectedTMS && this.selectedSearchTMS) {
        this.TMSError = 'Invalid TMS!';
        this.entryError.push({ key: 'cargoTypeTMS', value: 'Invalid TNS Value!' });
      }
      if (!this.selectedCON && this.selectedSearchCON) {
        this.CONError = 'Invalid CON!';
        this.entryError.push({ key: 'cargoTypeCON', value: 'Invalid CON Value!' });
      }
      if (this.DemurrageDays > 255) {
        this.DemurrageDaysError = 'Demurrage Days cannot be more than 255!';
        this.entryError.push({ key: 'cargoTypeDemurrageDays', value: 'Demurrage Days cannot be more than 255!' });
      }
      return this.entryError.length == 0;
    },
    clearEntryMessages: function () {
      this.entryMessages = [];
      this.cargoTypeCodeError = '';
      this.cargoTypeDescriptionError = '';
      this.DemurrageDaysError = '';
      this.TMSError = '';
      this.CONError = '';
    },
  },
  async mounted() {
    this.$bus.$on('pageSASControlAccess', (x) => {
      if (x.page == 'Cargo Type') {
        x.data.forEach((k) => {
          //key in menu same as control value from api
          const selectedMenu = this.menus.find((m) => m['key'] == k['Control']);
          if (selectedMenu) {
            selectedMenu[k['Properties'].toLowerCase()] = k['PropertiesValue'] == 'True';
          }
        });
      }
    });
    await this.getCargoType();

    if (this.$route.query['new']) {
      this.menuClicked({ title: 'New Cargo Type' });
    }
  },
  watch: {
    popupEntryShow: async function (val) {
      if (!val && this.$route.query['new'] && !this.viewMode) {
        // When the cancel is click but is not saved (for query new=1)
        const closeWindow = await this.$showAlert(
          'warning',
          'Cancelling Cargo Type Creation',
          `You have not created an Cargo Type profile.\nAre you sure you want to cancel?\n\nIf you cancel, this page will close.`,
          [{ text: 'Continue Creating' }, { text: 'Cancel Creating', color: 'red', textColor: 'white' }],
        );

        if (closeWindow == 'Cancel Creating') {
          // If user choose to cancel the creating process, it will close the tab
          window.close();
        } else {
          this.popupEntryShow = true;
        }
      } else if (!val && this.$route.query['new'] && this.viewMode) {
        window.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.cargoType-main {
  padding: 10px 45px;
  font-size: 12px;
  display: flex;

  > .right-container {
    width: 100%;
    height: 100%;
    background-color: white;
    padding: 5px;
    margin-left: 5px;
    border-radius: 5px;
  }
}

.additional-details {
  padding-top: 3px;
}
</style>
